// Mapeo compartido de event_key → { label, icon } para mostrar disparadores
// con nombre humano en la lista de bots y otros lados.
//
// La lista canónica vive en TriggerEditor.vue (EVENT_GROUPS). Este archivo
// la duplica de forma plana para consumo de otros componentes que solo
// necesitan resolver event_key → label/icon.

export const TRIGGER_OPTIONS = [
  // Cuando un lead NUEVO llega
  { key: 'first_message',         icon: '💬', label: 'Primer mensaje en WhatsApp / IG / canal',  trigger_type: 'message_received' },
  { key: 'email_received',        icon: '📧', label: 'Email recibido',                           trigger_type: 'message_received' },
  { key: 'form_submitted',        icon: '📝', label: 'Formulario web enviado',                   trigger_type: 'webhook' },
  { key: 'lead_created',          icon: '🆕', label: 'Lead creado en una etapa',                 trigger_type: 'stage_created' },
  { key: 'lead_created_or_moved', icon: '📍', label: 'Lead creado o movido a una etapa',         trigger_type: 'stage_any' },
  { key: 'ig_mention',            icon: '📸', label: 'Mención en historia de Instagram',         trigger_type: 'message_received' },
  // Cuando un lead AVANZA
  { key: 'stage_changed',         icon: '➡️', label: 'Lead movido a una etapa',                  trigger_type: 'stage_changed' },
  { key: 'message_in_stage',      icon: '✍️', label: 'Lead escribe estando en una etapa',        trigger_type: 'message_received' },
  { key: 'first_message_in_stage',icon: '🎯', label: 'Primer mensaje del cliente en una etapa',  trigger_type: 'message_received' },
  { key: 'tag_added',             icon: '🏷️', label: 'Etiqueta agregada al lead',                trigger_type: 'tag_added' },
  { key: 'field_updated',         icon: '📋', label: 'Campo del lead actualizado',               trigger_type: 'webhook' },
  // Cuando un lead se ENFRÍA
  { key: 'no_response_hours',     icon: '💤', label: 'N horas sin respuesta del cliente',        trigger_type: 'webhook' },
  { key: 'no_activity_days',      icon: '⏳', label: 'N días sin actividad',                     trigger_type: 'webhook' },
  { key: 'closed_ago',            icon: '✅', label: 'Conversación cerrada hace N tiempo',       trigger_type: 'webhook' },
  // Acción puntual del cliente
  { key: 'call_received',         icon: '📞', label: 'Llamada recibida / perdida',               trigger_type: 'webhook' },
  { key: 'message_read',          icon: '👁️', label: 'Mensaje saliente leído por el cliente',    trigger_type: 'webhook' },
  { key: 'comment_post',          icon: '💭', label: 'Comentario en post de IG/FB',              trigger_type: 'message_received' },
  { key: 'website_visit',         icon: '🌐', label: 'Sitio web visitado',                       trigger_type: 'webhook' },
  { key: 'assignee_changed',      icon: '👤', label: 'Responsable cambiado',                     trigger_type: 'webhook' },
  // Recordatorios programados
  { key: 'specific_date',         icon: '📅', label: 'En fecha y hora específica',               trigger_type: 'webhook' },
  { key: 'daily',                 icon: '🔁', label: 'Diariamente a una hora',                   trigger_type: 'webhook' },
  { key: 'before_event',          icon: '🎂', label: 'N días antes de cumpleaños / evento',      trigger_type: 'webhook' },
];

// Fallback genérico por trigger_type cuando no hay event_key (triggers viejos sin migrar)
const TYPE_FALLBACK = {
  message_received: { icon: '💬', label: 'Mensaje recibido' },
  stage_created:    { icon: '🆕', label: 'Lead creado en etapa' },
  stage_any:        { icon: '📍', label: 'Lead movido a etapa' },
  stage_changed:    { icon: '➡️', label: 'Lead movido a etapa' },
  tag_added:        { icon: '🏷️', label: 'Etiqueta agregada' },
  webhook:          { icon: '⚡', label: 'Webhook externo' },
};

// Resuelve { label, icon } a partir de un trigger del bot.
// Acepta:
//   - { event_key: 'first_message', trigger_type: 'message_received' }
//   - solo trigger_type si event_key falta
//   - custom triggers con event_key custom:xxx → muestra "Personalizado"
export function resolveTriggerLabel(trigger) {
  if (!trigger) return { icon: '⚙️', label: 'Disparador' };
  const eventKey = trigger.event_key || trigger.eventKey;
  if (eventKey) {
    if (typeof eventKey === 'string' && eventKey.startsWith('custom:')) {
      return { icon: '⚙️', label: 'Disparador personalizado' };
    }
    const opt = TRIGGER_OPTIONS.find(o => o.key === eventKey);
    if (opt) return { icon: opt.icon, label: opt.label };
  }
  return TYPE_FALLBACK[trigger.trigger_type] || { icon: '⚙️', label: trigger.trigger_type || 'Disparador' };
}
